import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxInnerShadow,
      color: palette.common.white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      userSelect: 'none',
      minWidth: '180px',
      position: 'relative'
    },
    line1: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    noLots: {
      paddingTop: '10px'
    },
    lots: {
      paddingTop: '0px'
    },
    gold: {
      background: palette.gradient.gold,
      height: '100%',
      paddingRight: '4px',
      paddingBottom: '6px',
      paddingLeft: '15px',
      color: palette.title.primary
    },
    silver: {
      background: palette.gradient.silver,
      ppaddingRight: '4px',
      paddingBottom: '6px',
      paddingLeft: '15px',
      height: '109px'
    },
    bronze: {
      background: palette.gradient.bronze,
      paddingRight: '4px',
      paddingBottom: '6px',
      paddingLeft: '15px',
      height: '104px'
    },
    img: {
      maxWidth: '75px',
      maxHeight: '50px',
      transform: 'translate(-5px,7px)',
      '@media (max-width: 1140px)': {
        display: 'none'
      }
    },
    position: {
      fontSize: '140%',
      fontWeight: 700,
      margin: 0,
      '@media (max-width: 1140px)': {
        marginTop: '10px'
      }
    },
    note: {
      fontSize: '36px',
      fontWeight: 600,
      margin: 0,
      '@media (min-width: 1000px) and (max-width: 1140px)': {
        fontSize: '32px'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
